import { render, staticRenderFns } from "./PedidoPendiente.vue?vue&type=template&id=152a8655&"
import script from "./PedidoPendiente.vue?vue&type=script&lang=js&"
export * from "./PedidoPendiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports